import { render } from "./IntranetPage.vue?vue&type=template&id=49b5f116&scoped=true"
import script from "./IntranetPage.vue?vue&type=script&lang=js"
export * from "./IntranetPage.vue?vue&type=script&lang=js"

import "./IntranetPage.vue?vue&type=style&index=0&id=49b5f116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b5f116"]])

export default __exports__